import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'incident_status'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
